<template>
  <div
    :class="`row alert px-0 text-${getColorMode.text} my-4 border-${getColorMode.globalBackground}`"
  >
    <div :class="buttonName && buttonLink ? 'col-6' : 'col-12'">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb my-0">
          <li class="my-auto" style="padding-right: 10px">
            <h2 class="mb-0">{{ $route.meta.title }}</h2>
          </li>
          <li v-if="breadcrumb" class="breadcrumb-item breadcrumb-home my-auto">
            <router-link class="home-icon-link" :to="{ name: 'index' }"
              ><font-awesome-icon :icon="['fal', 'home-alt']"
            /></router-link>
          </li>
          <li v-else class="breadcrumb-item breadcrumb-home my-auto">
            <font-awesome-icon :icon="['fal', 'home-alt']" />
          </li>
          <template
            v-for="(value, key) in breadcrumb"
            v-bind:key="`breadcrumb-element-${key}`"
            class="my-auto"
          >
            <li
              v-if="isLast(key)"
              class="breadcrumb-item active my-auto"
              aria-current="page"
            >
              {{ value.text }}
            </li>
            <li v-else class="breadcrumb-item my-auto">
              <router-link :to="value.link">{{ value.text }}</router-link>
            </li>
          </template>
        </ol>
      </nav>
    </div>
    <div class="col-6" v-if="buttonName && buttonLink">
      <div class="text-end">
        <router-link
          class="btn btn-primary btn-create-table text-white ms-auto"
          :to="buttonLink"
          ><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon>
          {{ buttonName }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "breadcrumb",
  props: {
    breadcrumb: {
      type: Array,
    },
  },
  data() {
    return {
      buttonName: null,
      buttonLink: null,
    };
  },
  methods: {
    isLast(index) {
      return index === this.breadcrumb.length - 1;
    },
    getButtonData() {
      this.buttonName = this.$route.meta.buttonName;
      this.buttonLink = this.$route.meta.buttonLink;
    },
  },
  mounted() {
    this.getButtonData();
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
  },
};
</script>
